import { ReportService as OvermapReportService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ReportService extends OvermapReportService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
